<template>
  <!--资源质量检测报告-->
    <el-dialog class="el-dialogs" :title="title" :fullscreen="true" :close-on-click-modal="false"
               @keyup.enter.native="refreshList(1)" @submit.native.prevent :visible.sync="visible">
        <el-form size="small" ref="searchForm" :inline="true" :model="searchForm" :rules="rules"
                 label-width="110px">
            <el-form-item label-width="0">
                <el-button type="primary" @click="downLoad()" size="small">下载</el-button>
                <el-button @click="reset()" size="small">刷新</el-button>
            </el-form-item>
            <el-form-item label-width="0" prop="name" class="f_r">
                <el-input v-model.trim="name" @input="refreshList(1)" maxlength="20" placeholder="请输入关键字(限20字)"
                          clearable>
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
            </el-form-item>
        </el-form>
        <div v-if="dataListSelect.length" class="p_all1 Selected">
            已选择 <span>{{ dataListSelect.length }}</span> 项 <span
                class="specialColor" @click="emptyselectData">清空</span>
        </div>
        <el-table
                :data="dataList"
                v-loading="loading"
                @sort-change="sortChange"
                @selection-change="selectionChangeHandle"
                size="small" height="calc(100vh - 170px)"
                class="table" ref="multipleTable" row-key='id' border>
            <el-table-column fixed type="selection" :reserve-selection="true"></el-table-column>
            <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
            <el-table-column v-if="pageNme" prop="resourcesName" label="资源名称" show-overflow-tooltip></el-table-column>
            <el-table-column v-else prop="schemeName" label="方案名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="newSchemeType" label="检测类型" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createByName" label="检测人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createDate" label="检测时间" sortable show-overflow-tooltip></el-table-column>
            <el-table-column prop="inspectionResult" label="检测结果" show-overflow-tooltip></el-table-column>
            <el-table-column
                    fixed="right"
                    label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small"
                               @click="view(scope.row)">查看
                    </el-button>
                    <el-button type="text" size="small"
                               @click="deleteData(scope.row)">删除
                    </el-button>
                    <el-button type="text" size="small"
                               @click="downLoad(scope.row)">下载
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <see-file-detail ref="seeFileDetail"></see-file-detail>
    </el-dialog>
</template>

<script>
import SeeFileDetail from "@/components/testReport/seeFileDetail.vue";

export default {
    name: "schemeList",
    components: {SeeFileDetail},
    data() {
        return {
            title: '资源质量检测报告',
            visible: false,
            searchForm: {
                resourceName: '',
                qualityName: '',
                current: 1,
                size: 20,

            },
            name:"",
            total: 0,
            rules: {},

            loading: false,
            dataList: [],
            dataListSelect: [],
            selectData: {},
            pageNme:'',
        }
    },

    methods: {
        init(selectData,pageNme) {
            this.visible = true
            this.pageNme = pageNme
            this.name = ''
            this.selectData = selectData
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields()
                this.refreshList(1, 1)
            })
        },

        refreshList(type, clearSelect) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            this.loading = true
            let data
            if (this.pageNme){
                this.searchForm.resourceName = this.name
                data = {
                    ...this.searchForm,
                    qualityId:this.selectData.id,
                }
            }else {
                this.searchForm.qualityName = this.name
                data = {
                    ...this.searchForm,
                    resourcesId:this.selectData.id,
                }
            }
            this.$axios(this.api.academic.qualityinspectionreportList, data).then(data => {
                if (data && data.status) {
                    this.dataList = data.data.data
                    this.dataList.forEach(item => {
                        let typeName = item.schemeType.split(',')
                        let newSchemeType = []
                        typeName.forEach(item => {
                            if (item == 0) {
                                newSchemeType.push('真实性')
                            }
                            if (item == 1) {
                                newSchemeType.push('完整性')
                            }
                            if (item == 2) {
                                newSchemeType.push('可用性')
                            }
                            if (item == 3) {
                                newSchemeType.push('安全性')
                            }
                        })
                        this.$set(item, 'newSchemeType', newSchemeType.join(','))
                    })
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },

        // 刷新
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1)
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },

        emptyselectData() {
            this.$refs.multipleTable.clearSelection()
        },

        // 列表排序
        sortChange(column, type) {
            // sort: column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : '')
            console.log(column)
        },

        //下载
        downLoad(row) {
            if (row){
                this.fileBlobDownload(this.api.academic.downloadReport, {
                    id:row.id,
                }, row.resourcesName+".pdf", 'application/pdf','get')
            }else {
                if (this.dataListSelect.length == 0) {
                    this.$message.warning('请至少选择一条数据')
                    return
                }
                let ids = this.dataListSelect.map(item=>{
                    return item.id
                })
                this.fileBlobDownload(this.api.academic.downloadReportById, ids, "检测报告.zip", 'application/zip','post')
            }
        },

        //删除
        deleteData(row) {
            let list = row ? [row] : this.dataListSelect
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let ids = list.map(item => {
                return item.id
            })
            this.$confirm(`您是否确认删除数据?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.academic.qualityinspectionreportRemoveById, {ids}, 'delete').then(data => {
                    if (data && data.status) {
                        this.$message.success('删除成功')
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },

        //查看
        view(row) {
            this.$refs.seeFileDetail.init(row)
        },
    },
}
</script>

<style scoped>
.Selected {
    border: 1px solid #BC2124;
    border-radius: 3px;
    padding: 5px 10px;
    background: rgba(188, 33, 36, .1);

    span {
        color: #BC2124;
    }
}

.specialColor {
    margin-left: 15px;
    cursor: pointer;
}
</style>
